import React, { Component } from 'react';
import { connect } from 'react-redux';
import InputAdornment from '@material-ui/core/InputAdornment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

import { TextInput, Text, FormModal } from '../../components';
import validateInput from '../../services/FormValidation/validateInput';

import { resetPassword } from '../../actions/user';

class ResetPassword extends Component {
state = {
    code: '',
    newPassword: '',
    confirmPassword: '',
    passwordError: false,
    confirmPasswordError: false,
    notifyText: false,
    notifyTextColor: '',
    visibility: false
};

_toggleVisibility = () => {
    this.setState({
        visibility: !this.state.visibility
    });
};

_onBlur = (type) => {
    this.setState({
        [`${ type }Error`]: validateInput(type, this.state[type])
    });
};

_handleInputChange = (type, event) => {
    this.setState({
        [type]: event.target.value.trim()
    });
};

_confirm = () => {
    const codeError = validateInput(
        'presence',
        this.state.code
    );
    const newPasswordError = validateInput(
        'newPassword',
        this.state.newPassword
    );
    const confirmPasswordError = validateInput(
        'confirmPassword',
        this.state.confirmPassword
    );

    this.setState({
        codeError,
        newPasswordError,
        confirmPasswordError
    });

    if (newPasswordError || confirmPasswordError || codeError) {
        return false;
    }

    if (this.state.newPassword !== this.state.confirmPassword) {
        this.setState({
            notifyText: 'Your passwords do not match',
            notifyTextColor: 'red'
        });

        return false;
    }

    const success = this.props.dispatch(resetPassword({
        resetCode: this.state.code,
        newPassword: this.state.newPassword
    }, this.props.email, this.state.newPassword));

    if (success) {
        this.setState({
            notifyText: false
        });

        this.props.close();
    }

    return true;
};

render() {
    return (
        <FormModal
            open={true}
            close={this.props.close}
            title={'Reset Password'}
            disableBackdropClick
            disableEscapeKeyDown
            onSave={this._confirm}
        >
            {this.state.notifyText && (
                <Text
                    align="center"
                    color={this.state.notifyTextColor}
                    small
                    display="inline-block"
                >
                    {this.state.notifyText}
                </Text>
            )}

            <TextInput
                variant="outlined"
                label="Verification Code(check your email)"
                value={this.state.code}
                onBlur={() => this._onBlur('code')}
                onChange={(value) => this._handleInputChange('code', value)}
                error={Boolean(this.state.codeError)}
                helperText={this.state.codeError}
                fullWidth
                autofocus
            />

            <TextInput
                variant="outlined"
                label="New Password"
                value={this.state.newPassword}
                inputProps={{
                    endAdornment: (
                        <InputAdornment>
                            {this.state.visibility ? (
                                <VisibilityIcon
                                    style={{ cursor: 'pointer' }}
                                    onClick={this._toggleVisibility}
                                />
                            ) : (
                                <VisibilityOffIcon
                                    style={{ cursor: 'pointer' }}
                                    onClick={this._toggleVisibility}
                                />
                            )}
                        </InputAdornment>
                    )
                }}
                onBlur={() => this._onBlur('newPassword')}
                onChange={(value) => this._handleInputChange('newPassword', value)
                }
                error={Boolean(this.state.newPasswordError)}
                helperText={this.state.newPasswordError}
                secure={!this.state.visibility}
                fullWidth
            />

            <TextInput
                variant="outlined"
                label="Confirm New Password"
                value={this.state.confirmPassword}
                inputProps={{
                    endAdornment: (
                        <InputAdornment>
                            {this.state.visibility ? (
                                <VisibilityIcon
                                    style={{ cursor: 'pointer' }}
                                    onClick={this._toggleVisibility}
                                />
                            ) : (
                                <VisibilityOffIcon
                                    style={{ cursor: 'pointer' }}
                                    onClick={this._toggleVisibility}
                                />
                            )}
                        </InputAdornment>
                    )
                }}
                onBlur={() => this._onBlur('confirmPassword')}
                onChange={(value) => this._handleInputChange('confirmPassword', value)
                }
                error={Boolean(this.state.confirmPasswordError)}
                helperText={this.state.confirmPasswordError}
                secure={!this.state.visibility}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        this._confirm();
                        e.preventDefault();
                    }
                }}
                fullWidth
            />
        </FormModal>
    );
}
}

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loading: state.user.loading,
    meta: state.user.meta
});

export default connect(mapStateToProps)(ResetPassword);